import { render, staticRenderFns } from "./DescripDetails.vue?vue&type=template&id=9e550600&scoped=true&"
import script from "./DescripDetails.vue?vue&type=script&lang=js&"
export * from "./DescripDetails.vue?vue&type=script&lang=js&"
import style0 from "./DescripDetails.vue?vue&type=style&index=0&id=9e550600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e550600",
  null
  
)

export default component.exports